import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';
import { riskIdentSnippet } from '../../default/order/order';

export const orderConfig: DeepPartial<OrderConfig> = {
  paymentMethods: ['paypal', 'mastercard', 'visa', 'diners', 'discover'],
  externalUrls: {
    rsvDataProtection: {
      default: '/de/ratenschutz/datenschutz',
    },
    flexikontoPaymentPause: {
      default: '/service-hilfe/bezahlung-finanzierung/flexikonto-zahlpause',
    },
  },
  premium: {
    enabled: false,
    hasRuntimeOptions: false,
    hasLegalFooter: true,
    trackingDetail: 'Vorteilsclub',
  },
  flexikonto: {
    paymentProtectionCardEnabled: false,
  },
  riskIdent: {
    enabled: true,
    snippetId: riskIdentSnippet('FeXHS8'),
  },
  sovendus: {
    de: {
      trafficSourceNumber: '1263',
      trafficMediumNumber: { default: '6', mobile: '8', app: '42' },
    },
  },
};
